document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cert-finder').forEach(initCertFinder)
})

function initCertFinder(el) {
    const tree = JSON.parse(el.dataset.tree)
    const total = parseInt(el.dataset.total, 10) || 3
    const { texts } = tree
    const $ = (sel) => el.querySelector(sel)

    const question = $('.cert-finder__question')
    const optionsEl = $('.cert-finder__options')
    const qWrap = $('.cert-finder__question-wrap')
    const resultEl = $('.cert-finder__result')
    const centersWrap = $('.cert-finder__centers')
    const centersList = $('.cert-finder__centers-list')
    const centersMore = $('.cert-finder__centers-more')
    const backBtn = $('.cert-finder__back')
    const resultIcon = $('.cert-finder__result-icon')
    const stepDots = el.querySelectorAll('.cert-finder__step')

    $('.cert-finder__back-text').textContent = texts.backLabel
    $('.cert-finder__restart-text').textContent = texts.restartLabel
    $('.cert-finder__cta-primary-text').textContent = texts.ctaPrimary

    let history = []

    const areasFor = (catId) => tree.areas.filter((a) => a.categories.includes(catId))

    const getCategoryId = () => {
        for (let i = history.length - 1; i >= 0; i--) {
            if (history[i].categoryId != null) return history[i].categoryId
        }
        return null
    }

    const cloneIcon = (key, target) => {
        const source = $(`[data-icon-for="${key}"]`)
        if (!source?.firstElementChild) return false
        target.appendChild(source.firstElementChild.cloneNode(true))
        return true
    }

    const setResultIcon = (area) => {
        resultIcon.textContent = ''
        const catId = getCategoryId()
        if (catId != null && cloneIcon(`result-cat-${catId}`, resultIcon)) return
        cloneIcon(`result-area-${area.id}`, resultIcon)
    }

    backBtn.addEventListener('click', () => {
        if (!history.length) return
        const prev = history.pop()
        if (prev.step === 'categories') renderCategories()
        else if (prev.step === 'areas') renderAreas(prev.categoryId)
    })

    $('.cert-finder__restart').addEventListener('click', () => {
        history = []
        renderCategories()
    })

    renderCategories()

    function renderCategories() {
        updateProgress(1)
        setBack(false)

        transition(qWrap, resultEl, () => {
            question.textContent = texts.q1
            optionsEl.textContent = ''

            tree.categories.forEach((cat) => {
                const areas = areasFor(cat.id)
                if (!areas.length) return

                const meta = `${areas.length} ${areas.length === 1 ? 'certifiering' : 'certifieringar'}`
                const row = makeOptionRow(cat.name, `cat-${cat.id}`, meta)

                row.addEventListener('click', () => {
                    selectRow(row, () => {
                        history.push({ step: 'categories' })
                        if (areas.length === 1) {
                            history.push({ step: 'areas', categoryId: cat.id })
                            showResult(areas[0])
                        } else {
                            renderAreas(cat.id)
                        }
                    })
                })

                optionsEl.appendChild(row)
            })
        })
    }

    function renderAreas(catId) {
        updateProgress(2)
        setBack(true)

        transition(qWrap, resultEl, () => {
            question.textContent = texts.q2
            optionsEl.textContent = ''

            areasFor(catId).forEach((area) => {
                const row = makeOptionRow(area.title, `area-${area.id}`)
                row.addEventListener('click', () => {
                    selectRow(row, () => {
                        history.push({ step: 'areas', categoryId: catId })
                        showResult(area)
                    })
                })
                optionsEl.appendChild(row)
            })
        })
    }

    function showResult(area) {
        updateProgress(total)
        setBack(true)

        transition(resultEl, qWrap, () => {
            $('.cert-finder__result-label').textContent = texts.resultLabel
            $('.cert-finder__result-title').textContent = area.title
            $('.cert-finder__result-desc').textContent = area.description
            $('.cert-finder__result-link').href = area.url
            setResultIcon(area)
            renderCenters(area)
        })
    }

    function renderCenters(area) {
        centersList.textContent = ''

        if (!area.centers?.length) {
            centersWrap.classList.add('hidden')
            return
        }

        centersWrap.classList.remove('hidden')

        const tpl = $('.tpl-center-row').firstElementChild

        area.centers.forEach((center) => {
            const row = tpl.cloneNode(true)
            row.querySelector('.cert-finder__center-name').textContent = center.name

            if (center.address) {
                const addr = row.querySelector('.cert-finder__center-address')
                addr.textContent = center.address
                addr.classList.remove('hidden')
            }

            if (center.content) {
                const content = row.querySelector('.cert-finder__center-content')
                content.innerHTML = center.content
                content.classList.remove('hidden')
            }

            if (center.phone) {
                const phone = row.querySelector('.cert-finder__center-phone')
                phone.href = `tel:${center.phone}`
                phone.querySelector('.cert-finder__center-phone-text').textContent = center.phone
                phone.classList.remove('hidden')
            }

            if (center.website) {
                const web = row.querySelector('.cert-finder__center-website')
                web.href = center.website
                web.querySelector('.cert-finder__center-website-text').textContent = center.website
                    .replace(/^https?:\/\//, '')
                    .replace(/\/$/, '')
                web.classList.remove('hidden')
            }

            centersList.appendChild(row)
        })

        if (centersMore) {
            centersMore.classList.remove('hidden')
            centersMore.classList.add('flex')
        }
    }

    function makeOptionRow(label, iconKey, meta = null) {
        const row = $('.tpl-option-row').firstElementChild.cloneNode(true)
        const iconCircle = row.querySelector('.cert-finder__option-icon')

        cloneIcon(iconKey, iconCircle)
        row.querySelector('.cert-finder__option-label').textContent = label

        const metaEl = row.querySelector('.cert-finder__option-meta')
        if (meta) {
            metaEl.textContent = meta
            metaEl.classList.remove('hidden')
        } else {
            metaEl.remove()
        }

        return row
    }

    function updateProgress(current) {
        $('.cert-finder__step-label').textContent = texts.stepLabel
            .replace('{current}', current)
            .replace('{total}', total)

        stepDots.forEach((dot) => {
            const n = parseInt(dot.dataset.step, 10)
            const circle = dot.querySelector('.cert-finder__step-dot')
            const numEl = dot.querySelector('.cert-finder__step-num-inner')
            const checkEl = dot.querySelector('.cert-finder__step-check')
            const lineEl = dot.querySelector('.cert-finder__step-line-fill')

            circle.classList.remove(
                'bg-accent-primary',
                'border-accent-primary',
                'text-white',
                'bg-secondary-50',
                'text-accent-primary'
            )

            if (n < current) {
                circle.classList.add('bg-accent-primary', 'border-accent-primary', 'text-white')
                numEl.classList.add('hidden')
                checkEl.classList.remove('hidden')
            } else if (n === current) {
                circle.classList.add('bg-secondary-50', 'border-accent-primary', 'text-accent-primary')
                numEl.classList.remove('hidden')
                checkEl.classList.add('hidden')
            } else {
                numEl.classList.remove('hidden')
                checkEl.classList.add('hidden')
            }

            if (lineEl) {
                lineEl.classList.toggle('w-full', n < current)
                lineEl.classList.toggle('w-0', n >= current)
            }
        })
    }

    function setBack(visible) {
        backBtn.classList.toggle('hidden', !visible)
        backBtn.classList.toggle('flex', visible)
        backBtn.nextElementSibling.classList.toggle('invisible', visible)
    }

    function transition(showEl, hideEl, updateFn) {
        hideEl.classList.add('hidden')
        showEl.classList.remove('hidden')
        showEl.style.opacity = '0'
        showEl.style.transform = 'translateY(8px)'

        updateFn()

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                showEl.style.transition = 'opacity 0.25s, transform 0.25s'
                showEl.style.opacity = '1'
                showEl.style.transform = 'translateY(0)'
            })
        })
    }

    function selectRow(btn, cb) {
        btn.classList.add('bg-current/10')
        setTimeout(cb, 120)
    }
}
